var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef, useState } from 'react';
import { GetProductData, LoadProductDataItems, GetSectionData } from '@themes/common/data';
import ImportAxios from '@themes/common/axios';
import { stringify, parse } from 'qs';
import ProductGallery from '@themes/static-scripts/sb-empire/ProductGallery';
import { LoadedProducts, LoadedExtraProducts, isOptionSorted, setIsOptionSorted } from '../constants';
import { useCountdownReducer } from '../countdown';
const ProductSectionData = GetSectionData('static-product');
export const useVariantManagement = (variantId, isCart, productData, setProductPage, variants) => {
    const { actions: { loadCountdownFromHtml }, } = useCountdownReducer();
    const previousVariantId = useRef(null);
    const [variantChangeLoading, setVariantChangeLoading] = useState(false);
    const LoadProductVariantContents = useCallback((variant_id) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const selectedProductVariant = variants === null || variants === void 0 ? void 0 : variants.find((v) => { var _a; return ((_a = v.variant_id) === null || _a === void 0 ? void 0 : _a.toString()) === (variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString()); });
        const productUrl = selectedProductVariant === null || selectedProductVariant === void 0 ? void 0 : selectedProductVariant.url;
        const mainProductUrl = selectedProductVariant === null || selectedProductVariant === void 0 ? void 0 : selectedProductVariant.main_product_url;
        const mainUrlIsInVariants = variants === null || variants === void 0 ? void 0 : variants.some((v) => v.url.split('?')[0] === (mainProductUrl === null || mainProductUrl === void 0 ? void 0 : mainProductUrl.split('?')[0]));
        const newProduct = GetProductData(variant_id);
        if (!newProduct) {
            return;
        }
        const form = jQuery('form[data-sb-product-form]');
        const formData = new FormData(form[0]);
        const id = formData.get('id');
        const productId = formData.get('product-id');
        if ((id === null || id === void 0 ? void 0 : id.toString()) !== (variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString()) || (productId === null || productId === void 0 ? void 0 : productId.toLowerCase()) !== ((_a = newProduct.product_id) === null || _a === void 0 ? void 0 : _a.toString())) {
            let inputId = form.find('input[name="id"]');
            let inputProductId = form.find('input[name="product-id"]');
            if (!inputId.length) {
                inputId = jQuery(`<input type="hidden" name="id" value="${variant_id}" />`);
                form.append(inputId);
            }
            else {
                inputId.val(variant_id);
            }
            if (!inputProductId.length) {
                inputProductId = jQuery(`<input type="hidden" name="product-id" value="${newProduct.product_id}" />`);
                form.append(inputProductId);
            }
            else {
                inputProductId.val(newProduct.product_id);
            }
            formData.set('id', variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString());
        }
        if (productUrl && mainUrlIsInVariants) {
            const productDetails = jQuery('[data-product-details]');
            const productTitle = productDetails.find('.product-title');
            productTitle.html(newProduct.title);
            const search = new URLSearchParams(productUrl.split('?')[1]);
            search.set('variant', variant_id === null || variant_id === void 0 ? void 0 : variant_id.toString());
            const url = `${productUrl.split('?')[0]}?${search.toString()}`;
            window.history.replaceState(null, '', url);
        }
        setVariantChangeLoading(true);
        try {
            if (variant_id) {
                const newProduct = GetProductData(variant_id);
                const image_badges = (_b = globalThis.sbBadges) === null || _b === void 0 ? void 0 : _b.call(globalThis, newProduct, 'Product Gallery');
                setProductPage((state) => {
                    state.variantId = variant_id;
                    state.product = newProduct;
                    state.quantity = 1;
                });
                if (!isOptionSorted && newProduct.options_with_values && newProduct.options_with_values.length > 0) {
                    const sortOptions = () => {
                        const swatchKing = jQuery('variant-swatch-king');
                        if (swatchKing.length > 0) {
                            for (const { name, values } of newProduct.options_with_values) {
                                const option = swatchKing.find(`[option-name="${name}"]`);
                                if (option.length > 0) {
                                    const swatchView = option.find('ul.swatch-view');
                                    const swatches = swatchView.children();
                                    for (const value of values) {
                                        const swatch = swatches.filter(`[orig-value="${value}"]`);
                                        if (swatch.length > 0) {
                                            swatch.appendTo(swatchView);
                                        }
                                    }
                                }
                            }
                            setIsOptionSorted(true);
                        }
                        else {
                            setTimeout(sortOptions, 200);
                        }
                    };
                    sortOptions();
                }
                const axios = yield ImportAxios();
                const search = Object.assign({}, ((_c = parse(newProduct.url.split('?')[1])) !== null && _c !== void 0 ? _c : {}));
                const path = newProduct.url.split('?')[0];
                const loadExtraProducts = () => __awaiter(void 0, void 0, void 0, function* () {
                    const extraProductPath = `${path}?${stringify(Object.assign(Object.assign({}, search), { view: 'sb-extra-json' }))}`;
                    let extraProducts = LoadedExtraProducts[extraProductPath];
                    if (!extraProducts) {
                        const { data } = yield axios.get(extraProductPath);
                        extraProducts = data;
                        LoadedExtraProducts[extraProductPath] = data;
                    }
                    LoadProductDataItems(extraProducts !== null && extraProducts !== void 0 ? extraProducts : []);
                    setProductPage((state) => {
                        state.extraProducts = extraProducts !== null && extraProducts !== void 0 ? extraProducts : [];
                    });
                });
                const loadProductVariant = () => __awaiter(void 0, void 0, void 0, function* () {
                    var _d, _e, _f, _g, _h, _j, _k;
                    const productVariantPath = `${path}?${stringify(search)}`;
                    let htmlString = LoadedProducts[productVariantPath];
                    if (!htmlString) {
                        const { data } = yield axios.get(productVariantPath);
                        htmlString = data;
                        LoadedProducts[productVariantPath] = data;
                    }
                    const htmlContents = jQuery(htmlString);
                    // Load countdowns using Redux action
                    loadCountdownFromHtml({
                        htmlString,
                        productData: newProduct,
                    });
                    const lipscoreRating = htmlContents.find('.shopify-block.shopify-app-block');
                    const tabs = htmlContents.find('.shopify-section.tabs--container');
                    const recommendations = htmlContents.find('.shopify-section.sb-recommendation--container');
                    const galleries = htmlContents.find('.shopify-section.product-gallery--container');
                    const containers = [...tabs, ...recommendations, ...galleries, ...lipscoreRating];
                    for (const containerElement of containers) {
                        const container = jQuery(containerElement);
                        const existingContainer = jQuery(`#${containerElement.id}`);
                        const maxHeight = existingContainer.height();
                        existingContainer.css('min-height', `${maxHeight}px`);
                        const galleryImage = container.find('.product-gallery--image');
                        if (galleryImage.length) {
                            galleryImage.append(image_badges);
                        }
                        jQuery(`#${containerElement.id}`).html(container.html());
                    }
                    htmlContents.find('#shopify-section-sb-product-badges .sb-badge--list').appendTo('.sb-product-badges-block');
                    (_d = globalThis.initializeTabs) === null || _d === void 0 ? void 0 : _d.call(globalThis);
                    (_e = globalThis.initializeFitBlock) === null || _e === void 0 ? void 0 : _e.call(globalThis);
                    (_f = globalThis.initializeSbModal) === null || _f === void 0 ? void 0 : _f.call(globalThis);
                    (_g = globalThis.initializeAlgoliaRecommendation) === null || _g === void 0 ? void 0 : _g.call(globalThis);
                    (_h = globalThis.initializeaWishlistButtons) === null || _h === void 0 ? void 0 : _h.call(globalThis);
                    (_k = (_j = globalThis.rimg_shopify) === null || _j === void 0 ? void 0 : _j.init) === null || _k === void 0 ? void 0 : _k.call(_j, '[data-rimg="lazy"]', {
                        round: 1,
                    });
                    if (ProductSectionData) {
                        const gallery = new ProductGallery({
                            el: jQuery('[data-product-gallery]')[0],
                            sectionContext: null,
                            settings: ProductSectionData.settings,
                            isQuickshop: null,
                        });
                    }
                });
                yield loadExtraProducts();
                yield loadProductVariant();
            }
        }
        catch (error) {
            console.error('Error loading variant contents:', error);
        }
        finally {
            setVariantChangeLoading(false);
        }
    }), [variants, setProductPage, loadCountdownFromHtml]);
    useEffect(() => {
        if (isCart || variants.length <= 1) {
            if (variants.length == 1) {
                const loadProductCountdown = () => __awaiter(void 0, void 0, void 0, function* () {
                    const axios = yield ImportAxios();
                    const { data } = yield axios.get(globalThis.location.pathname);
                    const newProduct = GetProductData(variantId);
                    if (newProduct) {
                        loadCountdownFromHtml({
                            htmlString: data,
                            productData: newProduct,
                        });
                    }
                });
                loadProductCountdown();
            }
            return;
        }
        const changeEvent = (e) => {
            if (e instanceof CustomEvent) {
                const variant_id = e.detail.currentVariant.id;
                if (previousVariantId.current !== variant_id) {
                    previousVariantId.current = variant_id;
                    LoadProductVariantContents(variant_id);
                }
            }
        };
        globalThis.addEventListener('shopify-variants:switch-variant', changeEvent);
        const Initialize = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (previousVariantId.current) {
                return;
            }
            const search = new URLSearchParams(window.location.search);
            const variant_id = (_a = search.get('variant')) !== null && _a !== void 0 ? _a : variantId;
            previousVariantId.current = variant_id;
            yield LoadProductVariantContents(variant_id);
        });
        const InitializeDebounce = debounce(Initialize, 200);
        InitializeDebounce();
        return () => {
            InitializeDebounce.cancel();
            globalThis.removeEventListener('shopify-variants:switch-variant', changeEvent);
        };
    }, [variantId, isCart, LoadProductVariantContents, variants.length]);
    useEffect(() => {
        if (isCart || variants.length > 0) {
            return;
        }
        const fetchVariants = () => __awaiter(void 0, void 0, void 0, function* () {
            const axios = yield ImportAxios();
            const productUrl = globalThis.location.pathname;
            const search = new URLSearchParams('');
            search.set('view', 'sb-variants');
            const { data } = yield axios.get(`${productUrl}?${search.toString()}`);
            const swatches = jQuery('.variants-ui__option-swatch');
            for (const element of swatches) {
                const currentElement = jQuery(element);
                const product = data.find((data) => data.variant_options.includes(currentElement.attr('data-option-value')));
                if (product) {
                    jQuery(element).css('--background-image', `url(${product.image})`);
                }
            }
            LoadProductDataItems(data);
            setProductPage((state) => {
                state.variants = data;
            });
        });
        fetchVariants();
    }, [isCart, productData, productData.url, setProductPage, variants.length]);
    return {
        variantChangeLoading,
        LoadProductVariantContents,
    };
};
// Helper functions
const debounce = (func, wait) => {
    let timeout;
    const debounced = (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(null, args), wait);
    };
    debounced.cancel = () => clearTimeout(timeout);
    return debounced;
};
